import React, { useContext, useState, useRef, useEffect } from "react";
import ReactDOM from 'react-dom';
import { useTranslation } from "react-i18next";
import { Card, Col, Row } from "react-bootstrap"

import { ActionButton, IconButton } from "@fluentui/react";
import JqxGrid, { jqx } from 'jqwidgets-scripts/jqwidgets-react-tsx/jqxgrid';

import TemplateDoc from '../../../templates/sBook/Mantainers/tmp_LegalEntities.csv'
import { useGetLegalEntitiesMaintainer, useGetLegalEntityTypes } from "../../../hooks/services/sBook/useOfLegalEntity";
import { addLegalEntity, addLegalEntityList, deleteLegalEntity, getLegalEntityById, saveLegalEntityById } from "../../../services/sBook/legalEntity.service";
import { downloadCSV, getGridLocalization, isNullUndefinedOrEmpty, showMessage } from "../../../common/Helpers";
import ProfileVerify from "../../../components/Templates/Site/ProfileVerify";
import MessageBox from "../../../components/Common/Message/MessageBox";
import { __LegalEntityTypeNemo, __MessageTypes } from "../../../common/Dictionaries";
import MainAppContext from "../../../MainAppContext";
import MatrixToolbar from "../../../components/Products/sPrivilege/Matrix/MatrixToolbar";
import * as XLSX from 'xlsx';
import { applyFilters, executeScrollMovementToFixLockRowOnEditCell, handlerFilter, removeGridLocalStorageFilters, setterActionFired, useFilterActionComponentData } from "../../../common/Helpers/JqxGridFilter";
import 'jqwidgets-scripts/jqwidgets/styles/jqx.light.css';
export default function LegalEntity(props) {
    const { t } = useTranslation();
    const contextSite = useContext(MainAppContext);
    const profileHasAccess = !contextSite.onlyObserver || (contextSite.securityProps.isSAdmin ||  contextSite.securityProps.isAdmin)

    const gridRef = useRef();
    const fileInputRef = useRef(null);

    const [showRequiredGlobalMessage, setShowRequiredGlobalMessage] = useState(false);
    const [editingRows, setEditingRows] = useState([]);
    const [duplicatedRows, setDuplicatedRows] = useState([]);


    const [messageConfig, setMessageConfig] = useState({
        message : null,
        messageType : "",
        showMessage : false,
    });

    const [listLegalEntities, setListLegalEntities] = useState(null);
    useGetLegalEntitiesMaintainer(listLegalEntities, setListLegalEntities)

    const [listLegalEntityTypes, setListLegalEntityTypes] = useState(null);
    useGetLegalEntityTypes(listLegalEntityTypes, setListLegalEntityTypes)

    useFilterActionComponentData(gridRef, messageConfig, "LegalEntity");

    useEffect(() => {
        if (listLegalEntities === null) {
            removeGridLocalStorageFilters("LegalEntity")
        }

    }, [listLegalEntities]);

    const handlerAddNewRow = (obj) => {
        const records = gridRef.current.props.source.records;
        const _lowerId = records.length !== 0 ? records.reduce((min, obj) => obj.id < min ? obj.id : min, records[0].id) : 0;
        const lowerId = records.length === 0 ? -1 : (_lowerId > 0 ? ((_lowerId * -1) - 1) : _lowerId -1);

        const newRow = !obj ? {
            id:                    lowerId,
            legalEntityCode:       "",
            name:                  "",
            businessName:          "",
            legalEntityIdentifier: null,
            legalEntityTypeId:     null,
        } : {
            id:                    lowerId,
            legalEntityCode:       obj.legalEntityCode,
            name:                  obj.name,
            businessName:          obj.businessName,
            legalEntityIdentifier: obj.legalEntityIdentifier,
            legalEntityTypeId:     obj.legalEntityTypeId,
        };

        gridRef.current.beginupdate();
        gridRef.current.addrow(null, newRow, 'first');

        listLegalEntities.unshift(newRow);
        setListLegalEntities(listLegalEntities);

        if (editingRows.length > 0 ? editingRows.find(x => x === lowerId) === undefined : true) {
            editingRows.push(lowerId)
            setEditingRows(editingRows);
        }

        gridRef.current.endupdate();
        gridRef.current.updatebounddata('rows');
        setterActionFired("LegalEntity", 1)
    };

    const handlerUploadData = () => {
        fileInputRef.current.click();
    };

    const handlerFileUpload = (event) => {
        const file = event.target.files[0];
        const reader = new FileReader();

        reader.onload = (e) => {
            const data = new Uint8Array(e.target.result);
            const workbook = XLSX.read(data, { type: 'array' });
            const worksheet = workbook.Sheets[workbook.SheetNames[0]];
            const jsonData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });

            const convertedData = jsonData.slice(1).map((row, rowIndex) => {
                const convertedRow = {};

                row.forEach((cell, columnIndex) => {
                    const columnName = getColumns().find(x => x.index === columnIndex).dataField;
                    convertedRow[columnName] = cell;
                });

                convertedRow.id = null;

                return convertedRow;
            });

            convertedData.forEach(element => {
                handlerAddNewRow(element)
            });
        };

        reader.readAsArrayBuffer(file);
        fileInputRef.current.value = '';
    };

    const getValue = (column, row) => {
        const itemValue = column.editorOptions.find(x => x.key === row[column.dataField])

        return !isNullUndefinedOrEmpty(itemValue) ? itemValue.text : "";
    }

    const handlerExportData = (exportData) => {
        const workbook = XLSX.utils.book_new();

        const aux_rows = []

        if (exportData) {
            const aux_list = listLegalEntities.filter(x => x.id > 0);

            aux_list.forEach(row => {
                let aux_row = {};
                getColumns().forEach(column => {
                    if (column.exportable) {
                        if (column.columntype === 'dropdownlist') {
                            aux_row[column.dataField] = row[column.dataField] !== null ? getValue(column, row) : "";
                        }
                        else {
                            aux_row[column.dataField] = row[column.dataField];
                        }
                    }
                });
    
                aux_rows.push(aux_row);
            });
        }

        const worksheet = XLSX.utils.json_to_sheet(aux_rows, { header: getColumns().filter(x => (exportData ? x.exportable : x.uploadMasive)).map(column => column.dataField) });
        
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Data');

        if (exportData) {
            XLSX.writeFile(workbook, 'LegalEntities_ExportedData.xlsx');
        }
        else {
            XLSX.writeFile(workbook, 'LegalEntities_UploadTemplate.xlsx');
        }
    };

    const isInValidFormControls = (list) => {
        let isInvalidForm = false;
        const validItems = [];

        list.forEach(element => {
            if (validateObject(element)) {
                validItems.push(element)
            }
            else {
                isInvalidForm = true;
            }
        });
    
        return {isInvalidForm: isInvalidForm, validItems: validItems};
    };

    const handlerSaveAll = () => {
        const aux_list = listLegalEntities.filter(x => x.id <= 0);
        const valid_response = isInValidFormControls(aux_list);

        if (valid_response.validItems) {
            addLegalEntityList(valid_response.validItems).then((response) => {
                if (response.data.succeeded) {
                    setListLegalEntities(null)
                    showMessage(setMessageConfig, true, __MessageTypes.SUCCESS, t('data-lang-msg-operationperformed'))
                }
                else {
                    showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'))
                }
                setterActionFired("LegalEntity", 1)
            }).catch(() => {
                showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'))
                setterActionFired("LegalEntity", 1)
            });
        }
        else {
            showMessage(setMessageConfig, true, __MessageTypes.WARNING, t('data-lang-msg-requireddatanotset'))
        }
    };

    const onGetTemplateClick = (type) => {
        const linkExport = document.getElementById("btnGetTemplateJson");
        let exportFileName = "";
        let excelStrData = "Id;Name\n";
        
        switch (type) {
            case "LEType":
                exportFileName = t('data-lang-lbl-type') + ".csv";
                listLegalEntityTypes.forEach(element => {
                    excelStrData += element.key + ";" + element.title + "\n"
                });
                downloadCSV(excelStrData, "data:text/csv;charset=utf-8,%EF%BB%BF", linkExport, exportFileName);
                break;

            case "Data":
                const btnGetTemplate = document.getElementById('btnGetTemplate');
                btnGetTemplate.click();
                break;
            default:
                break;
        }
    };

    const handlerSave = async (itemId) => {       
        const item = gridRef.current.props.source.records.find(x => x.id === itemId);

        if (validateObject(item)) {
            
            if (validateExistence(item)) {
                if (item.id <= 0) {
                    item.legalEntityNemo = "";

                    await addLegalEntity(item).then(async (serviceResponse) => {
                        if (serviceResponse.data.succeeded) {
                            setEditingRows(editingRows.filter(x => x !== item.id))

                            listLegalEntities.forEach(element => {
                                if (element.id === parseInt(item.id)) {
                                    element.id = serviceResponse.data.data.id;
                                    element.legalEntityCode = serviceResponse.data.data.legalEntityCode;
                                    element.legalEntityNemo = serviceResponse.data.data.legalEntityNemo;
                                }
                            });

                            setListLegalEntities(listLegalEntities);
                            showMessage(setMessageConfig, true, __MessageTypes.SUCCESS, t('data-lang-msg-operationperformed'))
                        }
                        else {
                            showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'))
                        }        
                        setterActionFired("LegalEntity", 1)
                    }).catch(() => {
                        showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'))
                        setterActionFired("LegalEntity", 1)
                    });
                }
                else {
                    saveLegalEntityById(itemId, item).then(async (serviceResponse) => {
                        if (serviceResponse.data.succeeded) {
                            setEditingRows(editingRows.filter(x => x !== item.id))
                            showMessage(setMessageConfig, true, __MessageTypes.SUCCESS, t('data-lang-msg-operationperformed'))
                        }
                        else {
                            showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'))
                        }  
                        setterActionFired("LegalEntity", 1)
                    }).catch(() => {
                        showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'))
                        setterActionFired("LegalEntity", 1)
                    });
                } 

                setDuplicatedRows(duplicatedRows.filter(x => x !== item.id))
                setShowRequiredGlobalMessage(false);
            }
            else {
                duplicatedRows.push(item.id)
                setDuplicatedRows(duplicatedRows)
                showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-elementexist'))
            }
        }
        else {
            setShowRequiredGlobalMessage(true);
        }
    };

    const handlerDelete = async (itemId) => {
        if (itemId <= 0) {
            const newListLegalEntities = gridRef.current.props.source.records.filter(x => x.id.toString() !== itemId.toString());
            setListLegalEntities(newListLegalEntities)
            setEditingRows(editingRows.filter(x => x.toString() !== itemId.toString()));
        }
        else {
            await deleteLegalEntity(itemId).then(async (serviceResponse) => {
                if (serviceResponse.data.succeeded) {
                    const newListLegalEntities = gridRef.current.props.source.records.filter(x => x.id.toString() !== itemId.toString());

                    setListLegalEntities(newListLegalEntities)
                    setEditingRows(editingRows.filter(x => x.toString() !== itemId.toString()));
                    showMessage(setMessageConfig, true, __MessageTypes.SUCCESS, t('data-lang-msg-operationperformed'))
                    
                    gridRef.current.updatebounddata('rows');
                }
                else {
                    showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'))
                }
                setterActionFired("LegalEntity", 1)
            }).catch(() => {
                showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'))
                setterActionFired("LegalEntity", 1)
            });
        }
    };

    const handlerCancel = async (itemId) => {
        if (itemId === null) {
            const newListLegalEntities = listLegalEntities.filter(x => x.id !== itemId);
            setListLegalEntities(newListLegalEntities)
            setEditingRows(editingRows.filter(x => x !== itemId));
            showMessage(setMessageConfig, true, __MessageTypes.SUCCESS, t('data-lang-msg-operationperformed'))    
            setterActionFired("LegalEntity", 1)
        }
        else
        {
            await getLegalEntityById(itemId).then(async (serviceResponse) => {
                if (serviceResponse.data.succeeded) {
                    listLegalEntities.forEach(element => {
                        if (serviceResponse.data.data.id === element.id) {
                            for (const property in serviceResponse.data.data) {
                                element[property] = serviceResponse.data.data[property]
                            }
                        }
                    });
            
                    setListLegalEntities(listLegalEntities);
                    setEditingRows(editingRows.filter(x => x !== itemId));
                    showMessage(setMessageConfig, true, __MessageTypes.SUCCESS, t('data-lang-msg-operationperformed'))    
                }
                else {
                    showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'))
                }
                setterActionFired("LegalEntity", 1)
            }).catch(() => {
                showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'))
                setterActionFired("LegalEntity", 1)
            });
        }
    };

    const validateExistence = (object) => {
        let isValid = true;

        if (object.legalEntityTypeId === __LegalEntityTypeNemo.PROVEEDOR.Id) {
            if (listLegalEntities.some(x => object.id !== x.id && (x.legalEntityIdentifier === object.legalEntityIdentifier))) {
                isValid = false;
            }
        }

        return isValid;
    };

    const validateObject = (object) => {
        let isValid = object.businessName !== undefined && object.businessName !== null && object.businessName !== '';
        isValid = isValid ? object.legalEntityCode !== undefined && object.legalEntityCode !== null && object.legalEntityCode !== '' : isValid;
        isValid = isValid ? object.legalEntityIdentifier !== undefined && object.legalEntityIdentifier !== null && object.legalEntityIdentifier !== '' : isValid;
        isValid = isValid ? object.legalEntityTypeId !== undefined && object.legalEntityTypeId !== null && object.legalEntityTypeId !== '' : isValid;

        return isValid;
    };

    const getRowIdFromRowIndex = (rowIndex) => {
        if (typeof rowIndex === 'object' && rowIndex.boundindex !== undefined) {
            return listLegalEntities[rowIndex.boundindex].id;
        }
        return listLegalEntities[rowIndex]?.id;
    };

    const onCellvaluechanged = (e) => {
        const currentColumn = e.owner._columns.find(x => x.datafield === e.args.datafield);

        if (currentColumn.columntype === "dropdownlist") {
            listLegalEntities[e.args.rowindex][e.args.datafield] = e.args.value.value
        }
        else {
            listLegalEntities[e.args.rowindex][e.args.datafield] = e.args.value
        }

        const copia_listContracts = JSON.parse(JSON.stringify(listLegalEntities));
        setListLegalEntities(copia_listContracts);

        if (editingRows.find(x => x === listLegalEntities[e.args.rowindex].id) === undefined) {
            editingRows.push(listLegalEntities[e.args.rowindex].id)
        }

        setEditingRows(editingRows);
        applyFilters(gridRef, 'LegalEntity', false);

        executeScrollMovementToFixLockRowOnEditCell(gridRef);
    };

    const actionCellsRenderer = (objSource) => {
        const itemId = getRowIdFromRowIndex(objSource)
        const isEditing = editingRows.find(x => x === itemId);

        return  <>
                {
                    profileHasAccess &&
                    <>
                        {isEditing ? (
                            <>
                                {
                                    itemId <= 0 ? (
                                        <>
                                            <IconButton iconProps={{ iconName: 'Save' }} title="Guardar" ariaLabel="Guardar" onClick={() => fieldActionHandler(itemId, 'save')} />
                                            <IconButton iconProps={{ iconName: 'Delete' }} title="Eliminar" ariaLabel="Eliminar" onClick={() => fieldActionHandler(itemId, 'delete')} />
                                        </>
                                    ) : (
                                        <>
                                            <IconButton iconProps={{ iconName: 'Save' }} title="Guardar" ariaLabel="Guardar" onClick={() => fieldActionHandler(itemId, 'save')} />
                                            <IconButton iconProps={{ iconName: 'Cancel' }} title="Cancelar" ariaLabel="Cancelar" onClick={() => fieldActionHandler(itemId, 'cancel')} />
                                            <IconButton iconProps={{ iconName: 'Delete' }} title="Eliminar" ariaLabel="Eliminar" onClick={() => fieldActionHandler(itemId, 'delete')} />
                                        </>
                                    )
                                }
                            </>
                        ) : (
                            <IconButton iconProps={{ iconName: 'Delete' }} title="Eliminar" ariaLabel="Eliminar" onClick={() => fieldActionHandler(itemId, 'delete')} />
                        )}
                    </>
                }
                {
                    duplicatedRows.find(x => x === itemId) &&
                    <span style={{color: "red !important", fontSize: "20px", cursor: "pointer"}} title={t('data-lang-msg-elementexist')}> * </span>
                }
                </>
    };

    const fieldActionHandler = (itemId, actionType) => {
        switch (actionType) {
            case 'save':
                handlerSave(itemId)
                break;
            case 'delete':
                handlerDelete(itemId)
                break;
            case 'cancel':
                handlerCancel(itemId)
                break;
            default:
                break;
        }
    };

    const cellsRenderer = (rowIndex, cellValue, editor, cellText, width, height, auxListData, cellType, subType) => {
        switch (cellType) {
            case 'textbox':
                switch (subType) {
                    case "currency":
                        editor.jqxNumberInput({
                            decimalDigits: 3,
                            width: width,
                            spinButtons: false,
                            symbol: '$',
                            groupSeparator: ',',
                            decimalSeparator: '.',
                            digits: 19, 
                            max: 9999999999,
                        });
                        break;
                    case "number":
                        editor.jqxNumberInput({
                            decimalDigits: 3,
                            width: width,
                            spinButtons: true,
                            groupSeparator: ',',
                            decimalSeparator: '.',
                            digits: 19, 
                            max: 9999999999,
                        });
                        break;
                    default:
                        break;
                }
                break;
            case 'datetimeinput':
                break;
            case 'checkbox':
                editor.jqxCheckBox({ width: width });
                break;
                case 'dropdownlist':
                editor.jqxDropDownList({
                    width: width,
                    height: height,
                    source: getListColumnAdapter(auxListData, 'key', 'text'),
                    displayMember: 'text',
                    valueMember: 'key',
                    autoDropDownHeight: auxListData.length < 5
                });
            default:
                break;
        }
    };

    const cellRenderClassStyle = (row, columnfield, value, columnType) => {
        let className = "";
        switch (columnType) {
            case "textbox":
                if (value === '') {
                    className = 'jqx-custom-validation-red';
                }
                else {
                    className = '';
                }
                break;
            case "numberinput":
                if (value < 0 || value === '') {
                    className = 'jqx-custom-validation-red';
                }
                else {
                    className = '';
                }
                break;
            case "datetimeinput":
                if (value === '') {
                    className = 'jqx-custom-validation-red';
                }
                else {
                    className = '';
                }
                break;
            case "dropdownlist":
                if (value === null || value === '' || value === 0) {
                    className = 'jqx-custom-validation-red';
                }
                else {
                    className = '';
                }
                break
            default:
                break;
        }

        return className;
    };

    const getListColumnAdapter = (listObjetcs, key, text) => {
        return new jqx.dataAdapter({
            datafields: [
                { name: text, type: 'string' },
                { name: key, type: 'number' }
            ],
            datatype: 'array',
            localdata: listObjetcs
        }, { autoBind: true });
    };

    const getColumns = () => {
        const basicColumns = [
            { index: null, text: 'ID',                                  dataField: 'id',                   uploadMasive: false, exportable: false, width: '0px',   columntype: 'textbox', editable: false, hidden: true },
            { index: null, text: t('data-lang-lbl-actions'),            dataField: 'acciones',             uploadMasive: false, exportable: false, width: '5%', pinned: true,
                createwidget: (row, column, value, htmlElement) => { ReactDOM.render(actionCellsRenderer(row), htmlElement); },
                initwidget: (row, column, value, htmlElement) => { ReactDOM.render(actionCellsRenderer(row), htmlElement); },
            },
            { index: 0,    text: t('data-lang-lbl-code'),               dataField: 'legalEntityCode',       uploadMasive: true,  exportable: true,  width: '10%', createeditor: (rowIndex, cellValue, editor, cellText, width, height) =>  cellsRenderer(rowIndex, cellValue, editor, cellText, width, height, null,                 'textbox', 'string'), columntype: 'textbox',        cellclassname: (row, columnfield, value) => cellRenderClassStyle(row, columnfield, value, 'textbox'),       editable: profileHasAccess, pinned: true },
            { index: 1,    text: t('data-lang-lbl-nameshort'),          dataField: 'name',                  uploadMasive: true,  exportable: true,  width: '30%', createeditor: (rowIndex, cellValue, editor, cellText, width, height) =>  cellsRenderer(rowIndex, cellValue, editor, cellText, width, height, null,                 'textbox', 'string'), columntype: 'textbox',        cellclassname: (row, columnfield, value) => cellRenderClassStyle(row, columnfield, value, 'textbox'),       editable: profileHasAccess, pinned: true },
            { index: 2,    text: t('data-lang-lbl-businessname'),       dataField: 'businessName',          uploadMasive: true,  exportable: true,  width: '30%', createeditor: (rowIndex, cellValue, editor, cellText, width, height) =>  cellsRenderer(rowIndex, cellValue, editor, cellText, width, height, null,                 'textbox', 'string'), columntype: 'textbox',        cellclassname: (row, columnfield, value) => cellRenderClassStyle(row, columnfield, value, 'textbox'),       editable: profileHasAccess, pinned: true },
            { index: 3,    text: t('data-lang-lbl-identifier'),         dataField: 'legalEntityIdentifier', uploadMasive: true,  exportable: true,  width: '15%', createeditor: (rowIndex, cellValue, editor, cellText, width, height) =>  cellsRenderer(rowIndex, cellValue, editor, cellText, width, height, null,                 'textbox', 'string'), columntype: 'textbox',        cellclassname: (row, columnfield, value) => cellRenderClassStyle(row, columnfield, value, 'textbox'),       editable: profileHasAccess, pinned: true },
            { index: 4,    text: t('data-lang-lbl-type'),               dataField: 'legalEntityTypeId',     uploadMasive: true,  exportable: true,  width: '10%', createeditor: (rowIndex, cellValue, editor, cellText, width, height) =>  cellsRenderer(rowIndex, cellValue, editor, cellText, width, height, listLegalEntityTypes, 'dropdownlist'),      columntype: 'dropdownlist',   cellclassname: (row, columnfield, value) => cellRenderClassStyle(row, columnfield, value, 'dropdownlist'),  editable: profileHasAccess, displayfield: 'LegalEntityType_Id', editorOptions: listLegalEntityTypes },
        ]

        return basicColumns;
    };

    return (
        <div className="col-12 listWithActions h-100">
            <Card className="h-100">
                <Card.Header>
                    <Card.Title className="d-flex justify-content-between">
                        <h4><b>{t('data-lang-maintainer-title-legalentities')}</b></h4>
                    </Card.Title>
                </Card.Header>
                <Card.Footer>
                    <MessageBox
                        inputParam_Message={ messageConfig.message }
                        inputParam_Display={ messageConfig.showMessage }
                        inputParam_MessageType={ messageConfig.messageType }
                        inputParam_SetterMessage={ setMessageConfig }
                    />
                </Card.Footer>
                <Card.Body className="access-per-month-form-body h-100 overflow-hidden-deprecated">
                    <div className="align-items-center h-100">
                        <div className="d-none">
                            <input ref={fileInputRef} type="file" accept=".xlsx" onChange={handlerFileUpload} />
                            <a id="btnGetTemplate" href={TemplateDoc} download="LegalEntityTemplate.csv" style={{display: "none"}} rel="noreferrer noopener" target='_blank'>#</a>
                            <a id="btnGetTemplateJson" href={undefined} download="Template.csv" style={{display: "none"}} rel="noreferrer noopener" target='_blank'>#</a>
                        </div>
                        {
                            listLegalEntities && listLegalEntityTypes &&
                            <>
                                <Row>
                                    <Col>
                                        <MatrixToolbar
                                            inputParam_HandleSaveData={handlerSaveAll}
                                            inputParam_HandleUploadData={handlerUploadData}
                                            inputParam_HandleExportData={handlerExportData}
                                            inputParam_HandleAddRow={handlerAddNewRow}
                                            inputParam_Configuration={{
                                                buttons: {
                                                    showRowButtons: profileHasAccess,
                                                    showExportData: true,
                                                    showAddMasiveData: profileHasAccess,
                                                    showAddData: profileHasAccess,
                                                    showDownloadTemplate: profileHasAccess,
                                                    showSaveAllData: false,
                                                    groupedButtons: profileHasAccess
                                                },
                                                handlers: {
                                                    handlerSave: profileHasAccess ? handlerSave : null,
                                                    handlerDelete: profileHasAccess ? handlerDelete : null,
                                                    handlerCancel: profileHasAccess ? handlerCancel : null,
                                                },
                                                auxiliarListCallbackOnAdd: null,
                                            }}
                                            inputParam_ExternalExportTemplates={[
                                                {
                                                    id: 'btnMantGetTemplate',
                                                    key: 'btnMantGetTemplate',
                                                    text: t('data-lang-lbl-uploadtemplate'),
                                                    iconProps: { iconName: 'ExcelDocument' },
                                                    onClick: () => handlerExportData(false)
                                                },
                                                {
                                                    id: 'btnMantGetTemplateLE',
                                                    key: 'btnMantGetTemplateLE',
                                                    text: t('data-lang-lbl-legalentitytype'),
                                                    iconProps: { iconName: 'ExcelDocument' },
                                                    onClick: () => onGetTemplateClick('LEType')
                                                }
                                            ]}
                                            inputParam_CustomOpenPanel={false}
                                            showRequiredMessage={showRequiredGlobalMessage}
                                        />
                                    </Col>
                                    {
                                        profileHasAccess && 
                                        <Col className="col-auto">
                                            <ActionButton iconProps={{iconName: "Save"}} text="Save all data" onClick={() => handlerSaveAll()} />
                                        </Col>
                                    }
                                </Row>
                                <JqxGrid
                                    ref={gridRef}
                                    altrows={true}
                                    enabletooltips={true}
                                    width={'100%'}
                                    theme={'light'} 
                                    height={'500px'}
                                    editable={true}
                                    //pageable={true}
                                    sortable={true}
                                    filterable={true}
                                    showfilterrow={true} 
                                    localization={getGridLocalization(t)}
                                    source={ new jqx.dataAdapter({
                                        localData: listLegalEntities,
                                        dataType: 'array',
                                        dataFields: [
                                            { name: 'id',                    type: 'number' },
                                            { name: 'legalEntityCode',       type: 'string' },
                                            { name: 'name',                  type: 'string' },
                                            { name: 'businessName',          type: 'string' },
                                            { name: 'legalEntityIdentifier', type: 'string' },

                                            { name: 'legalEntityTypeId',     type: 'number' },
                                            { name: 'LegalEntityType_Id',    value: 'legalEntityTypeId', values: { source: listLegalEntityTypes, value: 'key', name: 'text' } },
                                        ],
                                        id: 'id'
                                    })}
                                    columns={getColumns()}
                                    onCellvaluechanged={onCellvaluechanged} 
                                    onFilter={(event) => handlerFilter(event, 'LegalEntity')}
                                />
                            </>
                        }
                    </div>
                </Card.Body>
            </Card>           
        </div>
    ); 
}